import { css, html } from "lit";
import { queryAssignedElements } from "lit/decorators.js";
import { createContext, provide } from "@lit/context";
import { when } from "lit-html/directives/when.js";
import "../../atom/Row/index.js";
import "../../atom/Text/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { mediaQueries } from "../../../responsive/index.js";
import { getGroupInputClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
const groupContext = createContext(Symbol("GroupedContext"));
let DsfFormGroup = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "medium";
    this.dsf_error = false;
    this.dsf_success = false;
    this.ctx = {
      getPosition: (elm) => {
        if (!elm) {
          return "ungrouped";
        }
        const slottedIndex = this.slottedElements.indexOf(elm);
        switch (slottedIndex) {
          case 0:
            return "first";
          case this.slottedElements.length - 1:
            return this.dsf_suffix ? "middle" : "last";
          case -1:
            return "ungrouped";
          default:
            return "middle";
        }
      },
      getLabel: () => this.dsf_label || "",
      getGroupInputClasses
    };
  }
  render() {
    const messageColor = this.dsf_error ? "text-error-300" : this.dsf_success ? "text-success-300" : "text-neutral-700";
    return html`
      <div class="flex flex-col">
        ${when(
      this.dsf_label,
      () => html`<label
              id="label"
              class=${`text-neutral-400 ${this.dsf_size === "small" ? "dsf-text-xxs mb-2" : "dsf-text-xs mb-4"}`}
              >${this.dsf_label}</label
            >`
    )}
        <div class="flex align-top s:flex-row mobile:flex-col">
          <slot></slot>
          ${when(
      this.dsf_suffix,
      () => html`
              <dsf-text
                dsf_nowrap
                dsf_level="xs"
                dsf_color_intensity="500"
                class=${`dsf-text-s flex items-center justify-center rounded-e-sm border border-neutral-100 bg-neutral-100 px-10 ${this.dsf_size === "small" ? "h-32" : "h-40"}`}
              >
                ${this.dsf_suffix}
              </dsf-text>
            `
    )}
        </div>
        ${when(
      this.dsf_message,
      () => html`<label id="label" class=${`dsf-text-xxs mt-2 ${messageColor}`}
              >${this.dsf_message}</label
            >`
    )}
      </div>
    `;
  }
};
DsfFormGroup.styles = [
  css`
      /* Make sure space is spaced out equally between children */
      ::slotted(*) {
        flex-grow: 1;
      }
      ::slotted(dsf-form-group-divider) {
        flex-shrink: 0;
        flex-grow: 0 !important;
        align-self: center;
        margin-right: calc(-0.5 * var(--dsf-form-group-divider-size));
        margin-left: calc(-0.5 * var(--dsf-form-group-divider-size));
        z-index: 4;
      }
    `,
  mediaQueries.mobile.down(css`
      ::slotted(dsf-form-group-divider) {
        margin-top: calc(-0.5 * var(--dsf-form-group-divider-size));
        margin-bottom: calc(-0.5 * var(--dsf-form-group-divider-size));
        align-self: flex-start;
        margin-left: calc(2 * var(--dsf-base-size) - (var(--dsf-form-group-divider-size) / 2));
        margin-right: unset;
        transform: rotate(90deg);
      }
    `)
];
__decorateClass([
  queryAssignedElements()
], DsfFormGroup.prototype, "slottedElements", 2);
__decorateClass([
  prop({ type: String })
], DsfFormGroup.prototype, "dsf_suffix", 2);
__decorateClass([
  prop({ type: String })
], DsfFormGroup.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfFormGroup.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: String })
], DsfFormGroup.prototype, "dsf_message", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfFormGroup.prototype, "dsf_error", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfFormGroup.prototype, "dsf_success", 2);
__decorateClass([
  provide({ context: groupContext })
], DsfFormGroup.prototype, "ctx", 2);
DsfFormGroup = __decorateClass([
  defineElement("dsf-form-group")
], DsfFormGroup);
export {
  DsfFormGroup,
  groupContext
};
